import jQuery from 'jquery';

import { PAGES, PAGE_SELECTORS } from '../constants';

const DISABLED_SCROLL_HTML_CLASS = 'ui-disabledScroll__html';
const DISABLED_SCROLL_BODY_CLASS = 'ui-disabledScroll__body';

class CardPage {
    constructor() {
        const activePage = Object.keys(PAGES)
            .find(page => jQuery(PAGE_SELECTORS[PAGES[page]]).length);

        this.currentPage = PAGES[activePage];
        this.$html = jQuery('html');
        this.$body = jQuery('body');
        this.addScroll = this.addScroll.bind(this);
        this.removeScroll = this.removeScroll.bind(this);
    }

    addScroll() {
        this.$html.removeClass(DISABLED_SCROLL_HTML_CLASS);
        this.$body.removeClass(DISABLED_SCROLL_BODY_CLASS);
        if (this.startPosition > 0) {
            jQuery(window).scrollTop(this.startPosition);
            this.startPosition = 0;
        }
    }

    removeScroll() {
        this.startPosition = jQuery(window).scrollTop();
        this.$html.addClass(DISABLED_SCROLL_HTML_CLASS);
        this.$body.addClass(DISABLED_SCROLL_BODY_CLASS);
    }

    getCurrentPage() {
        return this.currentPage;
    }
}

export default new CardPage();



// WEBPACK FOOTER //
// ./lib/js/modules/cardPage.js